import { createFileRoute, redirect } from '@tanstack/react-router';

// The API redirects here after a successful OIDC handshake. By the time we
// arrive the session cookie is already set; we just need to hand control
// back to the / route so its beforeLoad re-fetches /api/v1/me and renders
// the authed shell. Anything that lands here that *did* fail would be
// redirected by the API to /login?error=... directly (eventually — see
// 0.6c), not here.
export const Route = createFileRoute('/auth/callback')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
